// eslint-disable-next-line
import { useState, useEffect } from "react";
import axios from "axios";
import { Stack, Typography, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function Main() {
  const [apexdomains, set_apexdomains] = useState();

  const sx = { wrapper: { width: 1200, height: 1, alignItems: "center" } };

  useEffect(() => {
    axios({ method: "get", url: `${process.env.REACT_APP_BE_URL}/apexes` })
      .then((data) => {
        set_apexdomains(data.data.apexes);
      })
      .catch((error) => console.log(error));
  }, []);

  return (
    <Stack sx={sx.wrapper}>
      <Apexdomains apexdomains={apexdomains} />
    </Stack>
  );
}

function Apexdomains({ apexdomains }) {
  const navigate = useNavigate();

  const sx = {
    wrapper: { width: 1, backgroundColor: "", border: "1px solid lightgrey" },
  };

  if (!apexdomains) return <Typography>Loading for apexdomains...</Typography>;
  return (
    <Stack sx={sx.wrapper} divider={<Divider flexItem />}>
      {apexdomains.map((e, i) => (
        <Typography key={i} onClick={() => navigate(`/scan/${e.name}`)}>
          {e.name} {e.sizes[3]} {e.updatedAt}
        </Typography>
      ))}
    </Stack>
  );
}

// row: {
// width: "calc(100% - 20px)",
// p: "10px",
// justifyContent: "space-between",
// alignItems: "center",
// backgroundColor: "",
// },

// cell_head: { width: 2 / 9, alignItems: "center", backgroundColor: "" },
// cell: { width: 1 / 9, backgroundColor: "", textAlign: "right" },
// cell_tail: {
// width: 2 / 9,
// justifyContent: "flex-end",
// alignItems: "center",
// backgroundColor: "",
// },
